import React from "react";

/**
 * GatewayIdInput Component
 * Renders a text input for the Gateway ID with validation feedback.
 * Props:
 *  - state: form state object
 *  - handleChange: input change handler
 */
const GatewayIdInput = ({ state, handleChange }) => {
  return (
    <div className="form-floating mb-4 position-relative">
      <input
        type="text"
        className={`form-control ${
          state.errors.Gateway ? "is-invalid" : state.Gateway ? "is-valid" : ""
        }`}
        id="Gateway"
        name="Gateway"
        value={state.Gateway}
        onChange={handleChange}
        required
        placeholder=" "
        autoComplete="off"
      />
      <label htmlFor="Gateway">Gateway ID</label>

      {/* Show error tooltip if validation fails */}
      {state.errors.Gateway && (
        <div className="invalid-tooltip">{state.errors.Gateway}</div>
      )}

      {/* Show success tooltip if field is valid */}
      {state.Gateway && !state.errors.Gateway && (
        <div className="valid-tooltip">Gateway ID is valid</div>
      )}
    </div>
  );
};

export default GatewayIdInput;
